import {useContentContext} from "./ContentProvider";

const StaticContents = (contentType: string) => {
  const {translations} = useContentContext()

  switch (contentType) {
    case "insuranceAgent":
      return (
        <div className="bg-white px-6 py-32 lg:px-8">
          <div className="mx-auto max-w-3xl text-base leading-7 text-gray-700">
            <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Vakuutusasiamies</h1>
            <p className="mt-6">Palvelumme auttaa sinua vertailemaan vakuutuksia. Palvelusta vastaava
              Little Buck Oy, joka on vakuutusasiamies ja edustaa useita vakuutusyhtiötä.</p>
            <p className="mt-6">Little Buck Oy:llä on vakuutusasiamiessopimus edustamiensa
              vakuutusyhtiöiden kanssa. Nämä sopimukset ovat rekisteröity Finanssivalvonnan vakuutusedustajarekisteriin.
              Rekisterin tiedot voi tarkistaa osoitteesta <a href="https://www.finanssivalvonta.fi" target="_blank" className="underline">www.finanssivalvonta.fi</a></p>

            <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Vakuutusasiamiehen yhteystiedot</h2>
            <p className="mt-6">
              Little Buck Oy<br/>
              Maariankatu 1 B 44, 20100 Turku<br/>
              Sähköposti <a href="mailto:info@vakuutuslaskuri.fi" className="underline">info@vakuutuslaskuri.fi</a><br/>
              Internet <a href="http://www.vakuutuslaskuri.fi" target="_blank" className="underline">
              http://www.vakuutuslaskuri.fi</a><br/>
              Y-tunnus 285439-2
            </p>

            <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Edustamamme vakuutusyhtiöt</h2>
            <p className="mt-6">
              Suomen Vahinkovakuutus Oy / POP Vakuutus<br/>
              Lars Sonckin kaari 12, 02600, Espoo<br/>
              Puh. <a href="tel:0103910391" target="_blank" className="underline">
              010 3910 391</a><br/>
              Y-tunnus 2432824-6
            </p>
          </div>
        </div>
      )
    case "remoteSales":
      return (
        <div className="bg-white px-6 py-32 lg:px-8">
          <div className="mx-auto max-w-3xl text-base leading-7 text-gray-700">
            <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Etämyynnin
              ennakkotiedot</h1>
            <p className="mt-6">Etämyynnillä tarkoitetaan vakuutuksen tekemistä verkon, puhelimen, postin tai muun
              etävälineen avulla ilman vakuutuksenottajan ja vakuutusyhtiön edustajan henkilökohtaista tapaamista.</p>

            <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Vakuutuksenantaja</h2>
            <p className="mt-6">
              Vakuutuksenantajana on asiakkaan palvelussa valitsema vakuutusyhtiö. Asiakkaan valitseman vakuutusyhtiön
              yhteystiedot näkyvät vakuutusehdotuksessa. Asiakas voi samassa yhteydessä tutustua vakuutusyhtiön
              tuote-esitteeseen sekä yksityiskohtaisiin sopimusehtoihin.
            </p>

            <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Vakuutusasiamies</h2>
            <p className="mt-6">
              Little Buck Oy on eri vakuutusyhtiötä edustava vertailupalvelu, joka auttaa asiakkaitaan löytämään heidän tarpeitaan vastaavan vakuutustarjouksen. Little Buck Oy vastaa Vakuutuslaskuri.fi-palvelun toiminnasta.
            </p>
            <p className="mt-6">
              Little Buck Oy<br/>
              Maariankatu 1 B 44, 20100 Turku<br/>
              Sähköposti <a href="mailto:info@vakuutuslaskuri.fi" className="underline">info@vakuutuslaskuri.fi</a><br/>
              Internet <a href="http://www.vakuutuslaskuri.fi" target="_blank" className="underline">
              http://www.vakuutuslaskuri.fi</a><br/>
              Y-tunnus 285439-2
            </p>

            <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Julkiset rekisterit</h2>
            <p className="mt-6">
              Little Buck Oy on merkitty seuraaviin patentti- ja rekisterihallituksen ja verohallinnon yhteisen
              yritystietojärjestelmän <a href="http://www.ytj.fi" target="_blank" className="underline">
              http://www.ytj.fi</a> julkisiin rekistereihin:<br/>
              <br/>
              - Kaupparekisteri<br/>
              - Verohallinto<br/>
              - Ennakkoperintärekisteri<br/>
              - Arvonlisäverovelvollisuus ostajana tai omasta käytöstä arvonlisäverovelvollinen
            </p>

            <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Valvontaviranomainen</h2>
            <p className="mt-6">
              Little Buck Oy:n valvontaviranomainen on Finanssivalvonta<br/>
              Snellmanninkatu 6 ja Mikonkatu 8<br/>
              PL 103<br/>
              00101 Helsinki<br/>
              Puh. <a href="tel:01083151" target="_blank" className="underline">010 831 51</a><br/>
              <a href="https://www.finanssivalvonta.fi" target="_blank"
                 className="underline">www.finanssivalvonta.fi</a>
            </p>

            <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Tuotteiden pääominaisuudet
            </h2>
            <p className="mt-6">
              Vakuutuksen laajuutta ja sen keskeisiä rajoituksia koskevat tiedot sekä etämyynnin tuotekohtaiset
              ennakkotiedot löytyvät kunkin vakuutusyhtiön vakuutuksen tuote-esitteestä ja vakuutusehdoista.
            </p>
            <p className="mt-6">Vakuutuksen hintoihin ja maksamiseen liittyvät tiedot näkyvät yhtiöittäin ja
              tuotteittain palvelun vakuutusehdotuksessa.</p>

            <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Peruuttamisoikeus</h2>
            <p className="mt-6">Kuluttajasuojalain peruuttamisoikeutta koskevia säännöksiä ei sovelleta
              vakuutussopimuksiin, vaan niihin sovelletaan vakuutussopimuslain säännöksiä. Vakuutussopimuslain mukaan
              vakuutus on irtisanottava kirjallisesti. Irtisanotusta vakuutuksesta peritään vakuutusmaksu sen
              voimassaolon ajalta. Määräaikaisissa vakuutuksissa, joiden kesto on alle 30 vuorokautta, ei ole
              irtisanomisoikeutta.</p>

            <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Tiedot oikeusturvakeinoista</h2>
            <p className="mt-6">Tietoa asiakkaan käytettävissä olevista oikeussuojakeinoista saa kunkin vakuutusyhtiön
              yleisistä sopimusehdoista.</p>

            <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Muita tietoja</h2>
            <p className="mt-6">
              Vakuutussopimuksiin sovelletaan Suomessa voimassa olevaa lainsäädäntöä.<br/><br/>
              Little Buck Oy:n palvelukieli etämyynnissä on suomi.<br/><br/>
              Hakemus voidaan vahvistaa verkossa asiakkaan pankin tarjoamalla e-tunnistepalvelua käyttäen.
              Vakuutusyhtiön vastuun alkamisesta ja vakuutussopimuksen ajallista voimassaoloa koskevat tiedot löytyvät
              vakuutusyhtiöittäin ja tuotteittain eritellysti
            </p>
          </div>
        </div>
      )
    case "privacy":
      return (
        <div className="bg-white px-6 py-32 lg:px-8">
          <div className="mx-auto max-w-3xl text-base leading-7 text-gray-700">
            <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Rekisteriseloste</h1>
            <p className="mt-6">Henkilötietolain (523/1999) 10 §:n mukainen REKISTERISELOSTE.</p>
            <p className="mt-6">Tiedot voimassa alkaen 12.6.2022</p>
            <p className="mt-6">Yksityisyytesi on meille tärkeää. Tämä Rekisteriseloste määrittelee, mitä
              henkilökohtaisia
              tietoja keräämme sinulta ja miten käytämme näitä tietoja. Henkilökohtaiset tiedot ovat mitä tahansa
              tietoja,
              joista henkilö (jäljempänä ”Käyttäjä”) voidaan tunnistaa.</p>


            <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">ASIAKASREKISTERI</h2>

            <h3 className="mt-16 text-xl font-bold tracking-tight text-gray-900">Rekisterinpitäjä</h3>
            <p className="mt-6">Rekisterinpitäjällä tarkoitetaan sovellettavien tietosuojasta annettujen lakien
              mukaisesti
              Little Buck Oy:tä (jäljempänä ”Vakuutuslaskuri” tai ”me”). Vakuutuslaskuri on vastuussa siitä, että
              henkilötietoja käsiteltäessä noudatetaan vakuutuslain-, henkilötieto- ja sovellettavaa
              tietosuojalainsäädäntöä. Ratkaisuja, joita Vakuutuslaskuri tarjoaa itse tai yhteistyökumppaninsa kautta
              kutsutaan jäljempänä ”Palveluiksi”.</p>

            <h4 className="mt-16 text-lg font-bold tracking-tight text-gray-900">Rekisterinpitäjän yhteystiedot:</h4>
            <p className="mt-6">
              Little Buck Oy<br/>
              Maariankatu 1B 44,<br/>
              20100 Turku
            </p>

            <h4 className="mt-16 text-lg font-bold tracking-tight text-gray-900">Rekisteriasioita hoitava henkilö</h4>
            <p className="mt-6">
              Little Buck Oy<br/>
              Ari-Pekka Pelkonen<br/>
              Sähköposti <a href="mailto:info@vakuutuslaskuri.fi" className="underline">info@vakuutuslaskuri.fi</a><br/>
            </p>

            <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Henkilötietojen käsittelyn
              tarkoitus</h2>
            <h3 className="mt-16 text-xl font-bold tracking-tight text-gray-900">Henkilötietojen kerääminen</h3>
            <p className="mt-6">Keräämme ja käsittelemme Käyttäjää koskevia henkilötietoja erilaisilla tavoilla, jotka
              on
              selostettu jäljempänä.</p>
            <p className="mt-6">Suurin osa henkilötiedoista, joita käsittelemme, saadaan suoraan Käyttäjältä. Voimme
              kerätä
              henkilötietoja myös Palvelun tuottamisen yhteydessä, sekä erinäisistä rekistereistä kuten
              luottorekisteristä.
              Lisäksi henkilötietoja voidaan saada luovutuksina muilta yhtiöiltä vakuutus- ja tietosuojalainsäädännön
              mukaisesti.</p>

            <h4 className="mt-16 text-lg font-bold tracking-tight text-gray-900">Käyttäjän rekisteröitymisen yhteydessä
              kerätyt tiedot</h4>
            <p className="mt-6">Palvelumme on suunnattu henkilöille, joiden ikä on 18-vuotta tai suurempi.</p>
            <p className="mt-6">Kun Käyttäjä käyttää Palveluamme keräämme tietoja, joita tarvitaan vakuutustarjousten
              hakemiseksi
              vakuutusyhtiöiltä. Tässä yhteydessä keräämme joitakin henkilökohtaisia perustietoja, kuten:</p>
            <p className="mt-6">
              - Henkilön nimi<br/>
              - Henkilön henkilötunnus<br/>
              - Henkilön osoite- ja yhteystiedot<br/>
              - Henkilön ajoneuvon vakuuttamista varten tarvittavat tiedot kuten ajoneuvon rekisterinumero, ajoneuvon
              tekniset tiedot, sekä ajoneuvon omistajatiedot
            </p>

            <p className="mt-6">
              Asiakastiedot tallentuvat väliaikaisesti vakuutustarjoushakua varten. Asiakastiedot poistetaan
              vakuutusvertailun valmistuttua Palvelusta.
            </p>

            <h3 className="mt-16 text-xl font-bold tracking-tight text-gray-900">Palvelun käyttöön liittyvät tiedot</h3>
            <p className="mt-6">
              Saatamme kerätä tietoja myös automaattisesti, kun Käyttäjä käyttää Palveluamme. Nämä tiedot
              ovat:<br/><br/>
              1. Käyttäjän aktiivisuuden perusteella tallentuvat tiedot.
            </p>

            <h3 className="mt-16 text-xl font-bold tracking-tight text-gray-900">Tiedot,
              jotka saamme automaattisesti Palvelun käytöstä</h3>

            <p className="mt-6">
              Saamme myös teknisiä käyttäjätietoja Palvelustamme, kuten:<br/><br/>

              Aikaleimoja ja lokitietoja liittyen Palvelun käyttöön;<br/>
              Tietoja laitteista, joita käytetään Palveluun pääsemiseksi, mukaan lukien IP-osoitteet ja
              ohjelmistoversiot.
              Nämä tiedot saadaan Käyttäjän selainten ja evästeiden avulla.
            </p>

            <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Miten käytämme henkilötietoja</h2>
            <p className="mt-6">
            Käsittelemme henkilötietoja kolmeen pääasialliseen tarkoitukseen.
            </p>

            <h4 className="mt-16 text-lg font-bold tracking-tight text-gray-900">Palvelun tarjoaminen</h4>
            <p className="mt-6">Palvelumme käyttäminen vaatii henkilötietojen käsittelyä, jotta voimme hakea ja
              vertailla Käyttäjän puolesta vakuutusten hintoja ja sisältöjä. Lisäksi käsittelemme Käyttäjän henkilötietoja voimaan saatettaessa vakuutuksen Käyttäjän puolesta.</p>

            <h4 className="mt-16 text-lg font-bold tracking-tight text-gray-900">Palvelun kehittäminen ja tutkimus</h4>
            <p className="mt-6">Saatamme käyttää henkilötietoja parantaaksemme Palvelun laatua, ratkaistaksemme
              Palvelussa havaittuja ongelmia ja kehittääksemme palvelun ominaisuuksia Käyttäjiä varten. Tietojenkäsittely perustuu haluumme parantaa Palveluamme ja sen ominaisuuksia ja sisältöä Käyttäjillemme. Saatamme myös tuottaa nimettömiä tilastotietoja tutkimustarkoituksiin, mukaan lukien liiketoiminta-analytiikkaan.</p>

            <h3 className="mt-16 text-xl font-bold tracking-tight text-gray-900">Mitä rekisterimme sisältää</h3>
            <p className="mt-6">
              Rekisterimme sisältää seuraavia tietoryhmiä<br/><br/>

              1. Henkilön perustiedot (kuten henkilön nimi, henkilötunnus, osoite, sekä yhteystiedot)<br/>
              2. Henkilön vakuutettavan kohteen tiedot (kuten ajoneuvon rekisterinumero, ajoneuvon tekniset tiedot)<br/>
              3. Asiakassuhteen hoitamiseen tarvittavat henkilön antamat luvat<br/>
              4. Asiakassuhteen yhteydenpitoa koskevat tiedot (kuten henkilön yhteydenotot ja kirjeenvaihtotiedot)<br/>
              5. Vakuutuslaskuri-palvelun audit trail tiedot
            </p>

            <h3 className="mt-16 text-xl font-bold tracking-tight text-gray-900">Henkilötietojen jakaminen tai
              luovuttaminen</h3>
            <p className="mt-6">
              Saatamme antaa henkilötietoja kolmansille osapuolille:<br/><br/>

              - kun se on laissa sallittu tai vaadittu;<br/>
              - jos olemme osallisena fuusiossa, yrityskaupassa, tai liiketoiminnan tai sen osan myynnissä;<br/>
              - kun me uskomme vilpittömin mielin, että tietojen antaminen on välttämätöntä oikeuksiemme suojelemiseksi,
              Käyttäjän turvallisuuden tai muiden turvallisuuden suojelemiseksi, petoksen tutkimiseksi, tai valtiovallan
              vaatimusten täyttämiseksi.<br/><br/>
              Vakuutuslaskuri ei myy eikä anna Käyttäjien henkilötietoja kolmansille osapuolille.
            </p>

            <h3 className="mt-16 text-xl font-bold tracking-tight text-gray-900">Henkilötietojen siirtäminen EU:n/ETA:n ulkopuolelle</h3>
            <p className="mt-6">Pääsääntöisesti emme siirrä Käyttäjien henkilötietoja EU:n/ETA:n ulkopuolelle. Mikäli
              Vakuutuslaskuri käyttäisi luotettua palveluntarjoajaa, joka toimii Yhdysvalloissa, saatamme joutua
              siirtämään
              joitakin Käyttäjien henkilötietoja Yhdysvaltoihin. Valitsemme ainoastaan kumppaneiksemme
              palveluntarjoajia,
              jotka ovat sitoutuneet noudattamaan Euroopassa koskevia tietosuojalakeja, sekä noudattavat EU Privacy
              Shield –
              sopimusta.</p>

            <h3 className="mt-16 text-xl font-bold tracking-tight text-gray-900">Henkilötietojen säilytys</h3>
            <p className="mt-6">Käyttäjän henkilötietojen säilytyksen osalta noudatamme Suomessa voimassa olevien
              vakuutus-,
              henkilötieto- ja kirjanpitolainsäädännön edellyttämiä säilytysaikoja. Poistamme Käyttäjän henkilötiedot
              automaattisesti, kun velvollisuutemme eivät enää edellytä henkilötietojen säilyttämistä.</p>

            <h3 className="mt-16 text-xl font-bold tracking-tight text-gray-900">Käyttäjän tietosuojaoikeudet</h3>

            <p className="mt-6">Käyttäjällä on oikeus saada ne henkilötiedot, jotka meillä on hallussamme kyseisestä
              Käyttäjästä. Käyttäjällä on oikeus oikaista, päivittää, muuttaa tai poistaa henkilötiedot milloin tahansa.
              Mikäli voimassa oleva lainsäädäntö edellyttää tiettyjen henkilötietojen säilyttämistä, kyseisiä tietoja
              Käyttäjä ei saa poistaa, vaan ne poistetaan automaattisesti käyttäjän puolesta, lainsäädännön niin
              salliessa.</p>

            <p className="mt-6">Käyttäjällä on oikeus kieltää tiettyä tietojenkäsittelyä, kuten profilointia ja
              markkinointia. Käyttäjällä on myös oikeus rajoittaa tietojenkäsittelyä siinä määrin kuin sovellettava
              tietosuojaa koskeva laki tätä edellyttää.</p>

            <p className="mt-6">Käyttäjällä on oikeus, lain edellyttämissä rajoissa, tietojen siirrettävyyteen.
              Käyttäjällä
              on toisin sanoen oikeus saada henkilötietonsa selkeässä luettavassa muodossa. Henkilötiedot toimitetaan
              yleisesti käytetyssä, konelukuisessa muodossa.</p>

            <p className="mt-6">Käyttäjällä on oikeus tehdä valitus Käyttäjän kansalliselle tietosuojaviranomaiselle
              EU:ssa/ETA:ssa, jos Käyttäjä kokee tietojenkäsittelymme ongelmaksi. Suomessa tämä viranomainen on
              tietosuojavaltuutettu.</p>

            <h3 className="mt-16 text-xl font-bold tracking-tight text-gray-900">Evästeet</h3>
            <p className="mt-6">Käytämme evästeitä tai muita samankaltaisia tekniikoita Palvelun tarjoamisessa. Evästeet
              ovat pieniä tekstitiedostoja, jotka on sijoitettu Käyttäjän laitteelle keräämään normaaleja internetin
              lokitietoja. Palvelun tietyt toiminnallisuudet vaativat evästeiden käyttöä. Käytämme evästeitä
              lisätäksemme
              Palvelun toimivuutta ja tehdäksemme siitä helpomman käyttää.</p>
            <p className="mt-6">Käyttäjä voi asettaa selaimensa asetukset siten, että se ei hyväksy evästeiden käyttöä.
              Käyttäjä voi myös rajoittaa evästeiden käyttöä tai poistaa evästeet selaimelta. On syytä huomauttaa, että
              evästeiden käytön rajoittaminen saattaa vaikuttaa Palvelun toimivuuteen.</p>

            <h3 className="mt-16 text-xl font-bold tracking-tight text-gray-900">Turvallisuus</h3>
            <p className="mt-6">Suhtaudumme turvallisuuteen vakavasti. Teemme erilaisia toimenpiteitä suojellaksemme
              henkilötietoja häviämiseltä, väärinkäytöltä ja niiden luvattomalta saamiselta tai paljastamiselta.</p>

            <h3 className="mt-16 text-xl font-bold tracking-tight text-gray-900">Rekisteriselosteen muutokset</h3>
            <p className="mt-6">Saatamme muuttaa rekisteriselostettamme aika ajoin. Ilmoitamme muutoksista
              sivuillamme.</p>
          </div>
        </div>
      )
    default:
      return (
        <div></div>
      )
  }
}

export default StaticContents
